import { render, staticRenderFns } from "./UploadHistory.vue?vue&type=template&id=6fbc8800&scoped=true"
import script from "./UploadHistory.vue?vue&type=script&lang=js"
export * from "./UploadHistory.vue?vue&type=script&lang=js"
import style0 from "./UploadHistory.vue?vue&type=style&index=0&id=6fbc8800&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fbc8800",
  null
  
)

export default component.exports